<template>
  <div class="client-account-detail-view">
    <dx-responsive-box>
      <dx-row />
      <dx-row />
      <dx-row />
      <dx-row />
      <dx-row />
      <dx-row />
      <dx-col />
      <dx-col screen="md lg" />
      <dx-col screen="md lg" />

      <dx-item>
        <dx-location :row="0" :col="0" />
        <div class="detail-element-container padding-right">
          Reg.nr.:
          <dx-number-box
            :value="row.data.registrationNumber"
            :read-only="true"
            class="textbox-readonly" />
            <dx-string-length-rule
              :min="3"
              message="Kontos registreringsnummer skal angives med mindst 3 cifre."
            />
        </div>
      </dx-item>

      <dx-item>
        <dx-location :row="0" :col="1" />
        <dx-location screen="xs sm" :row="1" :col="0" />
        <div class="detail-element-container">
          Kontonummer:
          <dx-number-box
            :value="row.data.accountNumber"
            :read-only="true"
            class="textbox-readonly" />
            <dx-string-length-rule
              :min="3"
              message="Kontonummer skal angives med mindst 3 cifre."
            />
        </div>
      </dx-item>

      <dx-item>
        <dx-location :row="1" :col="0" />
        <dx-location screen="xs sm" :row="1" :col="0" />
        <div class="detail-element-container padding-right">
          Beskrivelse:
          <dx-text-area
            :value="row.data.description"
            :read-only="true"
            class="textbox-readonly" />
        </div>
      </dx-item>

      <dx-item>
        <dx-location :row="2" :col="0" />
        <dx-location screen="xs sm" :row="2" :col="0" />
        <div class="detail-element-container">
          <dx-checkbox
            :value="row.data.isPrimaryAccount"
            :read-only="true"
            text="Primær konto"
            class="textbox-readonly padding-top" />
          <dx-checkbox
            :value="row.data.isPrimaryMCConnectAccount"
            :read-only="true"
            text="Primær MC Connect konto"
            class="textbox-readonly padding-top" />
        </div>
      </dx-item>

      <dx-item>
        <dx-location :row="0" :col="2" :rowspan="6" />
        <dx-location screen="xs sm" :row="6" :col="0" />
        <div>
          <div class="action-button-wrapper">
            <dx-button icon="edit" text="Rediger" @click="$emit('onEditClick', row)" class="action-button" />
          </div>
          <div class="action-button-wrapper">
            <dx-button icon="trash" text="Slet" @click="$emit('onDeleteClick', row)" class="action-button" />
          </div>
        </div>
      </dx-item>
    </dx-responsive-box>
  </div>
</template>

<script>
export default {
  name: 'DetailView',
  props: {
    row: Object,
  },
  setup() {
  },
};
</script>

<style lang="scss">
.client-account-detail-view {
  .action-button-wrapper {
    display: flex;
    justify-content: flex-end;

    .action-button {
      margin-bottom: 5px;
      width: 140px;
    }
  }

  .dx-checkbox.dx-state-readonly .dx-checkbox-icon {
    border-style: dashed;
    border-color: #ddd;
  }

  .dx-checkbox.dx-state-readonly .dx-checkbox-icon,
  .textbox-readonly {
    background-color: #FAFAFA !important;
  }

  .detail-element-container {
    padding-bottom: 10px;
  }

  .padding-top {
    padding-top: 15px;
  }

  .red-text {
    color: red;
  }
}
</style>
